export const SET_CURRENT_SLIDE = 'SET_CURRENT_SLIDE';
export const RESET_FOLIO = 'RESET_FOLIO';

export const TOGGLE_FOLIO_NAVIGATION = 'TOGGLE_FOLIO_NAVIGATION';

export const ENABLE_SLIDES = 'ENABLE_SLIDES';
export const DISABLE_SLIDES = 'DISABLE_SLIDES';

export const UNAUTHED_REDIRECT = 'UNAUTHED_REDIRECT';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';
export const REDIRECT_TO_ADMIN = 'REDIRECT_TO_ADMIN';



// WEBPACK FOOTER //
// ./src/actions/action-types.js